<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
        :isMonthly="true"
      />
      <search-dsp-select v-model="tableParams.dspId"/>
      <search-dsp-slot-select
        v-model="dspSlotIdList"
        :dsp-id="tableParams.dspId"
        multiple
      />
      <search-dsp-label-select
        v-model="tableParams.tag"
        :dsp-id="tableParams.dspId"
        :dsp-slot-id="dspSlotIdList"
        @upTag="upTag"
      />
      <search-budget-type v-model="tableParams.budget"/>
      <search-slot-Type-select v-model="tableParams.slotTypeId"/>
      <el-select
        v-model="tableParams.appType"
        clearable
        placeholder="请选择设备类型"

      >
        <el-option label="Android" :value="1"></el-option>
        <el-option label="ios " :value="2"></el-option>
        <el-option label="鸿蒙" :value="3"></el-option>
        <el-option label="其他" :value="4"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.subjectId"
        clearable
        placeholder="请选择主体"

      >
        <el-option
          v-for="item in subjectList"
          :label="item.subjectName"
          :value="item.subjectId"
        ></el-option>
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px"/>
      <el-button @click="toQuery" type="primary">搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        table-id="dspReport"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="downExcel('/report/dsp/list/xlsx', 'DSP报表', tableParams)"
          type="warning"
          size="small"
        >下载
        </el-button>
        <el-button @click="inspectDau" type="warning" size="small"
        >检查dau
        </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="handleDisable"
        >
        </el-table-column>

        <el-table-column
          v-if="
            tableParams.isDay === 1 ||
            tableParams.isHour === 1 ||
            tableParams.isMonth === 1
          "
          prop="reportTime"
          :label="
            tableParams.isDay === 1 || tableParams.isMonth === 1
              ? '日期'
              : '时间'
          "
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :sortable="
            v.field === 'reportTime' ||
            v.field === 'dspSlotName' ||
            v.field === 'uniClkSmt' ||
            v.field === 'reqSmt' ||
            v.field === 'dauDspSlotReqSmt' ||
            v.field === 'effectiveFillingRate' ||
            v.field === 'effectiveShowRat' ||
            v.field === 'time' ||
            v.field === 'showRat' ||
            v.field === 'uniShowSmt' ||
            v.field === 'repSmt' ||
            v.field === 'fillingRate' ||
            v.field === 'clickRate' ||
            v.field === 'dpRate' ||
            v.field === 'dpSmt' ||
            v.field === 'resSmt' ||
            v.field === 'uniWinSmt' ||
            v.field === 'channelEcpm' ||
            v.field === 'ecpmAverage' ||
            v.field === 'auctionPrice' ||
            v.field === 'cpcPrice' ||
            v.field === 'profit' ||
            v.field === 'cpvAverage' ||
            v.field === 'profitRate' ||
            v.field === 'effectiveResSmt' ||
            v.field === 'winPrice'
          "
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <el-tag
              v-if="
                v.field === 'deeplinkNumberProportion' ||
                v.field === 'timeoutNumberProportion'
              "
              type="info"
            >
              {{ scope.row[v.field] }}
            </el-tag
            >
            <el-tag
              v-else-if="
                v.field === 'fillingRate' ||
                v.field === 'showRat' ||
                v.field === 'clickRate' ||
                v.field === 'dpRate' ||
                v.field === 'bidRate' ||
                v.field === 'profitRate' ||
                v.field === 'effectiveFillingRate' ||
                v.field === 'effectiveShowRat'
              "
              type="info"
            >{{ scope.row[v.field] }}%
            </el-tag
            >
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图表">
          <template v-slot="scope" align="center">
            <el-button
              size="mini"
              @click="openMyEchart(scope.row)"
              :disabled="scope.row['slotName']"
            >查看
            </el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="预算占比">
          <template v-slot="scope" align="center">
            <el-button
              size="mini"
              @click="openBudgetDialog(scope.row)"
              :disabled="scope.row['slotName']"
            >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="close"
      width="60%"
      :title="chartParam.title"
      append-to-body
    >
      <div>
        <el-radio-group v-model="chartTimeRadio" @change="changeChartTimeRadio">
          <el-radio-button label="最近3天"></el-radio-button>
          <el-radio-button label="最近7天"></el-radio-button>
          <el-radio-button label="最近15天"></el-radio-button>
          <el-radio-button label="本月"></el-radio-button>
          <el-radio-button label="上月"></el-radio-button>
        </el-radio-group>
        <div style="float: right">
           <base-date-picker :default-date="this.chartParam.defaultDate " @changeDate="changeChartDate"/>
          <el-checkbox v-model="this.checked" >对比</el-checkbox>
          <base-date-picker v-if="this.checked" :default-date="this.chartParam.defaultDate " @changeDate="changeChartDate2" style="margin-left: 15px"/>
        </div>

        <echart-time-comparison :listData="listData" title="时段对比"/>
      </div>

    </el-dialog>

    <el-dialog
      v-model="checkDialog"
      :close-on-click-modal="false"
      @close="closeCheckDialog"
      width="60%"
      append-to-body
    >
      <div>
        <div>
          日期:{{ this.tableParams.startTime }}-{{ this.tableParams.endTime }}
        </div>
        <div
          v-for="item in checkDauData.slotDauNumList"
          :key="item.slotId"
          style="padding: 10px"
        >
          <span style="margin-right: 10px">广告位:{{ item.slotName }},</span
          ><span>dau: {{ item.dauNum }}</span>
        </div>
        <div>合并后dau数为:{{ checkDauData.sumDauNum }}</div>
      </div>
    </el-dialog>

    <el-dialog
      v-model="budgetStatus"
      :close-on-click-modal="false"
      @close="closeBudgetDialog"
      width="50%"
      :title="budgetParam.title"
      append-to-body
    >
      <div>
        <el-button @click="
          downExcel(
            '/report/percentage/budget/download-excel',
            'DSP素材预算占比',
            budgetParam
          )
        " style="float: right">下载
        </el-button>
        <el-button @click="
          downExcel(
            '/report/percentage/budget/download-hour-excel',
            'DSP素材预算占比',
            budgetParam
          )
        " style="float: right;margin-right: 10px">按时下载
        </el-button>
        <el-select v-model="this.budgetParam.hour" clearable
                   placeholder="请选择时段" @change="changeBudgetChartDateHour"
                   style="width: 20%;float: right;margin-right: 10px">
          <el-option
            v-for="item in hourOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <base-date-picker :default-date="this.budgetParam.defaultDate " @changeDate="changeBudgetChartDate"
                          style="float: right"/>
        <h2>落地页预算占比</h2>
        <el-table border :data="this.listBudgetData.commonList" v-loading="budgetTableLoading">
          <el-table-column property="domain" label="域名" align="center"/>
          <el-table-column property="remark" label="预算" align="center"/>
          <el-table-column label="占比(ecpm)" align="center">
            <el-table-column v-for="(v, i) in columnConfig" :prop="v.prop" :key="i" :label="v.label" align="center">
              <template v-slot="scope">
                <span v-if="scope.row.dynamicProps">
                  {{
                    scope.row.dynamicProps[v.prop + '_percentage'] ? scope.row.dynamicProps[v.prop + '_percentage'] + '% (' + scope.row.dynamicProps[v.prop + '_price'] + ')' : '-'
                  }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <h2>苹果商店占比</h2>
        <el-table border :data="this.listBudgetData.appStoreList" v-loading="budgetTableLoading">
          <el-table-column property="domain" label="ID" align="center"/>
          <el-table-column property="remark" label="预算" align="center"/>
          <el-table-column label="占比(ecpm)" align="center">
            <el-table-column v-for="(v, i) in columnConfig" :prop="v.prop" :key="i" :label="v.label" align="center">
              <template v-slot="scope">
                <span v-if="scope.row.dynamicProps">
                  {{
                    scope.row.dynamicProps[v.prop + '_percentage'] ? scope.row.dynamicProps[v.prop + '_percentage'] + '% (' + scope.row.dynamicProps[v.prop + '_price'] + ')' : '-'
                  }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <h2>描述占比</h2>
        <el-table border :data="this.listBudgetData.descList" v-loading="budgetTableLoading">
          <el-table-column property="domain" label="描述" align="center"/>
          <el-table-column label="占比(ecpm)" align="center">
            <el-table-column v-for="(v, i) in columnConfig" :prop="v.prop" :key="i" :label="v.label" align="center">
              <template v-slot="scope">
                <span v-if="scope.row.dynamicProps">
                  {{
                    scope.row.dynamicProps[v.prop + '_percentage'] ? scope.row.dynamicProps[v.prop + '_percentage'] + '% (' + scope.row.dynamicProps[v.prop + '_price'] + ')' : '-'
                  }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchDspLabelSelect from "@/components/SearchDspLabelSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import TableColumn from "@/components/TableColumn";
import SearchBudgetType from "@/components/SearchBudgetType";
import SearchSlotTypeSelect from "@/components/SearchSlotTypeSelect";
import {
  getDspDetailReportList,
  getDspEchartsDetailReportList,
  getDspEchartTimeReportList,
  getDspList, getPercentageBudgetReport
} from "@/api/manage/dsp/dsp";
import {uuid} from "@/util/util";
import {dauDspInspect, getMasterSubjectInfo} from "@/api/report/dsp";

import initTableMixin from "@/mixins/initTable";
import {downExcelMixin} from "@/mixins/downExcel";
import EchartTimeComparison from "@/components/EchartTimeComparison/index.vue";

export default {
  name: "Dsp",
  components: {
    DateFormatSelect,
    SearchDspSelect,
    SearchDspLabelSelect,
    SearchDspSlotSelect,
    BaseDatePicker,
    TableColumn,
    SearchBudgetType,
    EchartTimeComparison,
    SearchSlotTypeSelect,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        {field: "dspName", title: "DSP平台"},
        {field: "dspSlotName", title: "广告位名称"},
        {field: "dspSlotCode", title: "广告位Code"},
        {field: "reqSmt", title: "请求数"},
        {field: "realDauSmt", title: "真实DAU"},
        {field: "dauDspSlotReqSmt", title: "请求dau"},
        {field: "resSmt", title: "填充数"},
        {field: "effectiveResSmt", title: "有效填充"},
        {field: "fillingRate", title: "填充率"},
        {field: "effectiveFillingRate", title: "有效填充率"},
        {field: "uniShowSmt", title: "展示数"},
        {field: "showRat", title: "展示率"},
        {field: "effectiveShowRat", title: "有效展示率"},
        {field: "uniClkSmt", title: "点击数"},
        {field: "clickRate", title: "点击率"},
        {field: "deeplinkNumberProportion", title: "dp填充率"},
        {field: "timeoutNumberProportion", title: "超时率"},
        {field: "dpRate", title: "dp唤起率"},
        {field: "dpSmt", title: "唤起数"},
        {field: "cpcPrice", title: "CPC单价"},
        {field: "auctionPrice", title: "支出"},
        {field: "channelEcpm", title: "支出ecpm"},
        {field: "winPrice", title: "收入"},
        {field: "ecpmAverage", title: "收入ecpm"},
        { field: 'originalEcpmAverage', title: '原始收入ecpm' },
        {field: "originalWinPrice", title: "原始收入"},
        {field: "profit", title: "利润"},
        {field: "profitRate", title: "利润率"},
        {field: "time", title: "时长(毫秒)"},
        {field: "uniWinSmt", title: "竞得数"},
        {field: "bidRate", title: "竞得率"},
        {field: "cpvAverage", title: "百万请求消耗"},
      ],
      hides: [
        "uniWinSmt",
        "originalEcpmAverage",
        "bidRate",
        "cpcPrice",
        "effectiveResSmt",
        "effectiveShowRat",
        "effectiveFillingRate",
      ],
      hourOptions: [
        {value: '0', label: '0点'},
        {value: '1', label: '1点'},
        {value: '2', label: '2点'},
        {value: '3', label: '3点'},
        {value: '4', label: '4点'},
        {value: '5', label: '5点'},
        {value: '6', label: '6点'},
        {value: '7', label: '7点'},
        {value: '8', label: '8点'},
        {value: '9', label: '9点'},
        {value: '10', label: '10点'},
        {value: '11', label: '11点'},
        {value: '12', label: '12点'},
        {value: '13', label: '13点'},
        {value: '14', label: '14点'},
        {value: '15', label: '15点'},
        {value: '16', label: '16点'},
        {value: '17', label: '17点'},
        {value: '18', label: '18点'},
        {value: '19', label: '19点'},
        {value: '20', label: '20点'},
        {value: '21', label: '21点'},
        {value: '22', label: '22点'},
        {value: '23', label: '23点'}
      ],
      listData: [],
      listBudgetData: [],
      dateId: undefined,
      dialogStatus: false,
      budgetTableLoading: false,
      budgetStatus: false,
      dspSlotIdList: [],
      selectionColumn: [],
      checkDialog: false,
      checkDauData: [],
      slotIdLists: [],
      chartParam: {},
      checked: false,
      budgetParam: {},
      columnConfig: [],
      priceColumnConfig: [],
      chartTimeRadio: '今天',
      value: "",
      dauData: {
        data1: [],
        data2: [],
      },
      subjectList: [],
    };
  },
  created() {
    this.getSubjectInfo();
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    checked(val) {
      if (!val && this.dialogStatus) {
        this.chartParam.startTime2 = undefined;
        this.chartParam.endTime2 = undefined;
        this.fetchChartData();
      }
    }
  },
  methods: {
    getSubjectInfo() {
      getMasterSubjectInfo().then((res) => {
        this.subjectList = res.data;
      });
    },
    beforeInit() {
      this.tableUrl = "/report/dsp/list";
      this.tableParams.pageNum = this.pagination.pageNum;
      this.tableParams.pageSize = this.pagination.pageSize;
      return true;
    },
    afterInit(res) {
      this.tableData = this.generateTableId(res.data.records, 0);
    },
    handleDisable(row) {
      return !row.slotName;
    },
    upTag(tag) {
      this.tableParams.tag = tag;
    },
    sizeChange(e) {
      this.pagination.pageSize = e;
      this.tableParams.pageSize = e;
      this.init();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.tableParams.pageNum = e;
      this.init();
    },
    toQuery() {
      if (this.dspSlotIdList) {
        this.tableParams.dspSlotIdList = this.dspSlotIdList.join(",");
      }
      this.init();
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
    changeChartDate(date) {
      this.chartParam.startTime = date.startTime;
      this.chartParam.endTime = date.endTime;
      this.fetchChartData();
    },
    changeChartDate2(date) {
      this.chartParam.startTime2 = date.startTime;
      this.chartParam.endTime2 = date.endTime;
      this.fetchChartData();
    },
    fetchChartData() {
      const search = {
        dspSlotId: this.chartParam.dspSlotId,
        desc: "reportTime",
        startTime: this.chartParam.startTime,
        endTime: this.chartParam.endTime,
      };
      if (this.checked) {
        search.contrast = true;
        search.startTime2 = this.chartParam.startTime2;
        search.endTime2 = this.chartParam.endTime2;
      }
      getDspEchartTimeReportList(search).then(res => {
        if (res.code === 200) {
          this.listData = res.data;
        }
      });
    },
    changeBudgetChartDateHour() {
      this.changeBudgetChartDate();
    },
    changeBudgetChartDate(date) {
      this.budgetTableLoading = true;
      this.columnConfig = []
      this.priceColumnConfig = []
      if (date) {
        this.budgetParam.startTime = date.startTime;
        this.budgetParam.endTime = date.endTime;
      }
      const search = {
        dspSlotId: this.budgetParam.dspSlotId,
        startTime: this.budgetParam.startTime,
        endTime: this.budgetParam.endTime,
        hour: this.budgetParam.hour
      };
      getPercentageBudgetReport(search).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.listBudgetData = res.data
            this.columnConfig = res.data.columnConfig
            this.priceColumnConfig = res.data.priceColumnConfig
          } else {
            this.listBudgetData = {}
          }
        }
      }).finally(() => {
        this.budgetTableLoading = false
      })
    },
    changeChartTimeRadio() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      let start = new Date(today)
      let end = new Date(today)
      const DAY_MS = 86400000

      switch (this.chartTimeRadio) {
        case '最近3天':
          start.setTime(today.getTime() - DAY_MS * 2)
          break
        case '最近7天':
          start.setTime(today.getTime() - DAY_MS * 6)
          break
        case '最近15天':
          start.setTime(today.getTime() - DAY_MS * 14)
          break
        case '本月':
          start = new Date(year, month, 1)
          end = new Date(year, month + 1, 0) // 本月最后一天
          break
        case '上月':
          start = new Date(year, month - 1, 1)
          end = new Date(year, month, 0) // 上月最后一天
          break
        default:
          start.setTime(today.getTime() - DAY_MS * 2)
      }
      this.chartParam.defaultDate = [start, end]
    },
    changeDateFormatData(dateFormatId) {
      // this.dateId = dateFormatId
      this.tableParams.isDay = null;
      this.tableParams.isHour = null;
      this.tableParams.isMonth = null;
      if (dateFormatId === 0) {
        this.tableParams.isDay = 2;
        this.tableParams.isHour = 2;
        this.tableParams.isMonth = 2;
        this.tableParams.desc = "";
      } else if (dateFormatId === 1) {
        this.tableParams.isDay = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 2) {
        this.tableParams.isHour = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 3) {
        this.tableParams.isMonth = 1;
        this.tableParams.desc = "reportTime";
      }
    },
    selectionChange(selection) {
      this.selectionColumn = selection;
    },
    // 检查dau
    inspectDau() {
      if (this.selectionColumn.length > 0) {
        const slotIdList = [];
        this.selectionColumn.forEach((index) => {
          slotIdList.push(index.dspSlotId);
        });
        this.slotIdLists = slotIdList.toString();
        dauDspInspect({
          slotIdList: this.slotIdLists,
          pageNum: this.tableParams.pageNum,
          pageSize: this.tableParams.pageSize,
          startTime: this.tableParams.startTime,
          endTime: this.tableParams.endTime,
        }).then((res) => {
          if (res.code === 200) {
            this.checkDauData = res.data;
            this.checkDialog = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请先选择检查项");
      }
    },
    load(tree, treeNode, resolve) {
      this.$nextTick(() => {
        let time;
        if (this.tableParams.isDay === 1) {
          time = 2;
        } else if (this.tableParams.isHour === 1) {
          time = 1;
        } else if (this.tableParams.isMonth === 1) {
          time = 3;
        } else {
          time = 2;
        }
        const search = {
          dspSlotId: tree.dspSlotId,
          timeType: time,
          // budget:this.tableParams.budget,
          asc: this.tableParams.asc,
          desc: this.tableParams.desc,
        };
        if (tree.reportTime === undefined || this.tableParams.isMonth === 1) {
          search.finishTime = this.tableParams.endTime;
          search.startTime = this.tableParams.startTime;
          if (this.dateFormatId === 3) {
            search.startTime = search.startTime + '00'
            search.endTime = search.endTime + '23'
          }
        } else {
          search.finishTime = tree.reportTime;
          search.startTime = tree.reportTime;
        }
        getDspDetailReportList(search).then((res) => {
          if (res.code === 200) {
            resolve(this.generateTableId(res.data, tree.id));
          }
        });
      });
    },
    generateTableId(data, base) {
      if (!data) return [];
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid();

        if (base === 0) {
          data[i].hasChildren = true;
        } else {
          data[i].dspSlotCode = data[i].slotId;
          data[i].dspName = data[i].channelName;
          data[i].dspSlotName = data[i].slotName;
          data[i].dauDspSlotReqSmt = data[i].dauReqSmt;
        }
      }
      return data;
    },
    tableSummary(row) {
      const arr = [
        "reqSmt",
        "resSmt",
        "dauDspSlotReqSmt",
        "originalWinPrice",
        "uniShowSmt",
        "uniClkSmt",
        "dpSmt",
        "uniWinSmt",
        "auctionPrice",
        "profit",
        "winPrice",
        "realDauSmt",
      ];
      const fixedArr = ["auctionPrice", "winPrice", "profit", "originalWinPrice"];
      const fixed2Arr = [
        "channelEcpm",
        "ecpmAverage",
        "originalEcpmAverage",
        "fillingRate",
        "showRat",
        "clickRate",
        "dpRate",
        "bidRate",
      ];
      const {data} = row;
      const checklists = this.checkColumns.map((item) => {
        return item.field;
      });
      checklists.unshift("0");
      if (this.tableParams.isDay === 1 || this.tableParams.isHour === 1) {
        checklists.unshift("0");
      }
      const out = [];
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = "合计";
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data
                  .reduce((total, item) => {
                    return total + Number(item[checklists[i]]);
                  }, 0)
                  .toFixed(4)
                : "-";
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case "channelEcpm":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.auctionPrice);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(4);
                break;
              case "ecpmAverage":
                out[i] = (
                  (data
                      .reduce((total, item) => {
                        return total + Number(item.winPrice);
                      }, 0)
                      .toFixed(4) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(2);
                break;
              case "fillingRate":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.reqSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "showRat":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "clickRate":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "dpRate":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.dpSmt);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "bidRate":
                out[i] = (
                  (data.reduce((total, item) => {
                      return total + Number(item.uniWinSmt);
                    }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                  return total + Number(item[checklists[i]]);
                }, 0)
                : "-";
          }
        }
      }
      return out;
    },
    openMyEchart(data) {
      this.dialogStatus = true;
      this.chartParam.title = data.dspSlotName;
      this.chartParam.dspSlotId = data.dspSlotId;
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
      this.chartParam.defaultDate = [start, new Date()];
    },
    openBudgetDialog(data) {
      this.budgetStatus = true;
      this.budgetParam.title = data.dspSlotName;
      this.budgetParam.dspSlotId = data.dspSlotId;
      this.budgetParam.defaultDate = [new Date(), new Date()];
    },
    close() {
      this.listData = [];
      this.chartParam = {};
      this.chartTimeRadio = '今天';
      this.dialogStatus = false;
      this.checked = false
    },
    closeBudgetDialog() {
      this.columnConfig = []
      this.priceColumnConfig = []
      this.listBudgetData = [];
      this.budgetParam = {};
      this.budgetStatus = false;
    },
    closeCheckDialog() {
      this.checkDialog = false;
    },
    sortChange(column) {
      this.tableParams.asc = "";
      this.tableParams.desc = "";
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop;
      } else {
        this.tableParams.desc = column.prop;
      }
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

::v-deep.el-table__body-wrapper {
  order: 0;
}
</style>
